import Yggdrasil from 'services/yggdrasil'

const state = {
    userRatings: [],
    ratingSaved: false
}

const mutations = {
    ASSIGN_USER_RATINGS (state, ratings) {
        state.userRatings = ratings
    },
    CLEAR_AFTER_LOGOUT (state) {
        state.userRatings = []
    },
    SET_RATING_SAVED (state, savedState) {
        state.ratingSaved = savedState
    }
}

const actions = {
    async clearAfterLogout (store) {
        store.commit('CLEAR_AFTER_LOGOUT')
    },
    async loadUserRatings (store) {
        const userRatings = await Yggdrasil.loadUserRatings()
        store.commit('ASSIGN_USER_RATINGS', userRatings)
    },
    async sendRating (store, { courseId, rating }) {
        await Yggdrasil.sendCourseRating(courseId, rating)
    },
    async setRatingSaved (store, savedState) {
        store.commit('SET_RATING_SAVED', savedState)
    }
}

const getters = {
    getUserRatings: (state) => state.userRatings,
    getUserRateForCourse: (state) => (courseId) => state.userRatings.find(rating => +rating.courseId === +courseId),
    getRatingSavedState: (state) => state.ratingSaved
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
